import React, { useReducer, useCallback } from 'react'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Label, ModalBody } from 'reactstrap'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import Resx from '@/components/Resx'
import { Input } from '@/components/inputs'
import { DropDownList } from '@/components/dropDownList'

const initialState = {
  reportCode: '',
  treeCode: '',
  propertyName: ''
}

const actionTypes = {
  setReportCode: 'setReportCode',
  setTreeCode: 'setTreeCode',
  setPropertyName: 'setPropertyName'
}

function reducer (state, action) {
  switch (action.type) {
    case actionTypes.setReportCode: return { ...state, reportCode: action.data }
    case actionTypes.setTreeCode: return { ...state, treeCode: action.data }
    case actionTypes.setPropertyName: return { ...state, propertyName: action.data }
  }
}

function AddColumnBinding (props) {
  const { onAction } = props
  const [state, dispatch] = useReducer(reducer, { ...initialState })
  const { reportCode, treeCode, propertyName } = state

  const confirm = useCallback(() => { onAction({ ...state, propertyName: state.propertyName.item }) }, [onAction, state])
  const setReportCode = useCallback(e => dispatch({ type: actionTypes.setReportCode, data: e.target.value }), [])
  const setTreeCode = useCallback(e => dispatch({ type: actionTypes.setTreeCode, data: e.target.value }), [])
  const setPropertyName = useCallback(e => dispatch({ type: actionTypes.setPropertyName, data: e.item }), [])
  const bindingProps = [ 'Currency',
    'Iban',
    'AccountNumber',
    'BranchCode',
    'AvailableBalance',
    'BookBalance',
    'CreditLimit',
    'ReferenceRate'
  ].map(x => { return { item: x } })

  return (
    <ValidationBoundary>
      <BasicHeader title='Reporting.AddColumnBinding' {...props} />
      <ModalBody>
        <Label><Resx name='Reporting.ReportCode' /></Label>
        <Validator name='reportCode' value={reportCode} required>
          <Input value={reportCode} onChange={setReportCode} />
        </Validator>
        <Label><Resx name='Reporting.TreeCode' /></Label>
        <Validator name='treeCode' value={treeCode} required>
          <Input value={treeCode} onChange={setTreeCode} />
        </Validator>
        <Label><Resx name='Reporting.PropertyName' /></Label>
        <Validator name='propertyName' value={propertyName} required>
          <DropDownList
            data={bindingProps}
            onChange={setPropertyName}
            value={propertyName}
            textField='item'
            valueField='item' />
        </Validator>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...props} onAction={confirm} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: AddColumnBinding
}



// WEBPACK FOOTER //
// ./src/dialogs/addColumnBinding.js